interface SearchIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  customStyle?: React.CSSProperties;
}

export const SearchIcon: React.FC<SearchIconProps> = ({ 
  width = 24, 
  height = 24, 
  color = "#595959",
  className,
  customStyle
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={customStyle}
    >
      <path 
        d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}; 